import { render, staticRenderFns } from "./OrgMainContainer.vue?vue&type=template&id=6278659a&scoped=true"
import script from "./OrgMainContainer.vue?vue&type=script&lang=js"
export * from "./OrgMainContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6278659a",
  null
  
)

export default component.exports